import PreferenceSelector, {
  PreferenceSelectorProps,
} from './PreferenceSelector';

export type {PreferenceSelectorProps};
export default PreferenceSelector;
